import { t } from 'ttag'
import { useContext } from 'react'
import styled, { css } from 'styled-components'

import { Page } from '@h2/common/components/page'
import { Globals } from '@h2/globals'
import { Flex } from '@h2/components/layout/flex'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { NAVIANCEBLUE, WHITE } from '@h2/components/colors'
import navianceLinkedAccountSvg from '@h2/assets/svg/illustrations/navianceLinkedAccount.svg'
import { features } from '@h2/components/media'

import { Form } from './form'

import { Card } from '../card'
import { Wrap } from '../registration/highlights/components'

const HighlightWrap = styled(Wrap)`
  ${({isNavianceUser}) => isNavianceUser && css`
    & h2, & p {
      text-align: center;
    }
  `}
`
const FlexWrap = styled(Flex)`
  ${({isNavianceUser}) => isNavianceUser && css`
    flex-direction: column;
    align-items: center;
  `}
`
const Image = styled.img`
  width: 115px;
  height: auto;

  ${({isNavianceUser}) => isNavianceUser && css`
    width: 215px;
  `}

  @media (${features.minWidth.laptop}) {
    width: 100%;
  }
`
const ResetPassword = () => {
  const { isNavianceUser } = useContext(Globals)

  return isNavianceUser ? (
    <Card useDetour>
      <Card.Highlight color={NAVIANCEBLUE}>
        <HighlightWrap isNavianceUser={isNavianceUser} isNamePanel>
          <Heading level="2" color={WHITE}>
            {t`Link your Headed2 account to Naviance!`}
          </Heading>
          <FlexWrap isNavianceUser={isNavianceUser}>
            <Text color={WHITE} margin="0">
              {t`Link your Naviance and Headed2 accounts to access Headed2 features in Naviance.`}
            </Text>
            <Image isNavianceUser={isNavianceUser} src={navianceLinkedAccountSvg} alt="" />
          </FlexWrap>
        </HighlightWrap>
      </Card.Highlight>
      <Card.Content>
        <Heading level="2" align="center">{t`Reset your Password`}</Heading>
        <Form />
      </Card.Content>
    </Card>
  ) : (
    <Page>
      <Page.Title>{t`Reset your Password`}</Page.Title>
      <Page.Layout>
        <Page.Content>
          <Form />
        </Page.Content>
      </Page.Layout>
    </Page>
  )
}

export { ResetPassword }
